import { FtpSchemaTypes } from "@bfc-software/api-schemas";
import type { Middleware } from "openapi-fetch";
import { getEnv } from "@bfc-software/bfc-web-ui/environment";
import {
  aaaTokenOnly,
  useAuthenticatedApi,
  useAuthenticatedFetchClient,
} from "@bfc-software/bfc-web-ui/lib/authenticated-api";

export type JobStatus = FtpSchemaTypes.components["schemas"]["jobStatus"];
export type Job = FtpSchemaTypes.components["schemas"]["job"];
export type JobsResponse = FtpSchemaTypes.components["schemas"]["jobsResponse"];
export type JobDetailResponse =
  FtpSchemaTypes.components["schemas"]["jobDetailResponse"];
export type JobLog = FtpSchemaTypes.components["schemas"]["jobLog"];
export type JobLogDetailResponse =
  FtpSchemaTypes.components["schemas"]["jobLogDetailResponse"];
export type JobStats = FtpSchemaTypes.components["schemas"]["jobsStats"];
export type JobStatsWindow =
  FtpSchemaTypes.components["schemas"]["jobStatsWindow"];
export type JobsByFileType =
  FtpSchemaTypes.components["schemas"]["jobsByFileType"];
export type JobStatsResponse =
  FtpSchemaTypes.components["schemas"]["jobStatsResponse"];

type Paths = FtpSchemaTypes.paths;

/** The service also reads the token from the query string. Bearer is already on `request.headers`. */
const ftpTokenInQuery = (token: string | undefined): Middleware[] => [
  {
    onRequest: ({ request }) => {
      const originalUrl = new URL(request.url);
      if (token && !originalUrl.searchParams.has("token")) {
        originalUrl.searchParams.append("token", token);
      }
      return new Request(originalUrl.toString(), { headers: request.headers });
    },
  },
];

const spec = () => ({
  baseUrl: getEnv().ftpServiceBaseUrl,
  select: aaaTokenOnly,
  middleware: ftpTokenInQuery,
});

export const useFtpApi = () => useAuthenticatedApi<Paths>(spec());

/** Raw fetch client for imperative use (mutations, etc.). Rebuilt only when the token changes. */
export const useFtpFetchClient = () =>
  useAuthenticatedFetchClient<Paths>(spec());
